import axios from 'axios';
import { API_URL } from '../env';
import { normalize } from '../services/helpers';

export const create = async (opponentId) => {
  await axios.post(`${API_URL}/games`, {
    opponent_id: opponentId,
  });
};

/** Deletes the games: all of them, or none if any isn't the player's. */
export const destroyMany = async (gameIds) => {
  await axios.post(`${API_URL}/games/delete`, { ids: gameIds });
};

export const all = async () => {
  const response = await axios.get(`${API_URL}/games`, { params: { include: ['users', 'board'] } });

  return normalize(response.data);
};

export const get = async (id) => {
  const response = await axios.get(`${API_URL}/games/${id}`, {
    params: {
      include: [
        'activePokemon',
        'benches',
        'discardPiles',
        'deckPiles',
        'gameTurn',
        'gamePlayers',
        'hands',
        'prizePiles',
        'users',
        'options',
      ],
    }
  });

  return normalize(response.data);
};

/** The activity log, oldest first, as this player may see it; `withBoards`: each move's board too, for a replay. */
export const log = async (id, { withBoards = false } = {}) => {
  const response = await axios.get(`${API_URL}/games/${id}/log${withBoards ? '?include=board' : ''}`);

  return response.data.data;
};

/** You've seen the game up to `version`; answers how many of your games still have new moves. */
export const seen = async (id, version) => {
  const response = await axios.patch(`${API_URL}/games/${id}/seen`, { version });

  return response.data.games_with_new_moves;
};

export const setDeck = async (id, deckId) => {
  const response = await axios.patch(`${API_URL}/games/${id}/set-deck`, {
    deck_id: deckId,
  });

  return normalize(response.data);
};

export const pass = async (id) => {
  const response = await axios.patch(`${API_URL}/games/${id}/pass`);

  return normalize(response.data);
};

export const retreat = async (id, benchPosition, energyAttachmentIds) => {
  const response = await axios.patch(`${API_URL}/games/${id}/retreat`, {
    bench_position: benchPosition,
    energyAttachmentIds,
  });

  return normalize(response.data);
};

/** Other people's games to watch, most recently played first, each with its board and players (plain objects). */
export const watchList = async () => {
  const response = await axios.get(`${API_URL}/games/watch`);

  return response.data.data;
};

/** A game you're watching: its table as anyone may see it, and its players (a plain object). */
export const watched = async (id) => {
  const response = await axios.get(`${API_URL}/games/${id}`, { params: { include: ['board', 'users'] } });

  return response.data.data;
};
